module.exports = __webpack_public_path__ + "static/media/1-2-1.93f2446b.png";